import AdminLayout from "../layouts/AdminLayout";
import { hasPermission } from "../utils/permissions";
import { useEffect, useState } from "react";

function AdminDashboard() {
  const canView = hasPermission("dashboard", "view");

  const [stats, setStats] = useState({
    totalOrders: 0,
    totalProducts: 0,
    totalUsers: 0,
    totalAdmins: 0,
    pendingMandates: 0,
  });

  useEffect(() => {
    // Example mock stats - you can fetch actual values from API if needed
    setStats({
      totalOrders: 92,
      totalProducts: 41,
      totalUsers: 120,
      totalAdmins: 3,
      pendingMandates: 6,
    });
  }, []);

  if (!canView) {
    return (
      <AdminLayout>
        <p style={{ color: "red", fontWeight: "bold", padding: 20 }}>
          ❌ You do not have permission to view the dashboard.
        </p>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div style={styles.container}>
        <h2 style={styles.heading}>📊 Admin Dashboard</h2>

        <div style={styles.cardGrid}>
          <StatCard title="Total Products" count={stats.totalProducts} icon="📦" color="#00cec9" />
          <StatCard title="Total Orders" count={stats.totalOrders} icon="🧾" color="#74b9ff" />
          <StatCard title="Total Users" count={stats.totalUsers} icon="👥" color="#fd79a8" />
          <StatCard title="Admins" count={stats.totalAdmins} icon="🛡️" color="#a29bfe" />
          <StatCard title="Pending Mandates" count={stats.pendingMandates} icon="📄" color="#ffeaa7" />
        </div>
      </div>
    </AdminLayout>
  );
}

function StatCard({ title, count, icon, color }) {
  return (
    <div style={{ ...styles.card, backgroundColor: color }}>
      <div style={styles.icon}>{icon}</div>
      <div>
        <h3 style={styles.cardTitle}>{title}</h3>
        <p style={styles.cardCount}>{count}</p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    padding: 20,
    fontFamily: "Arial",
  },
  heading: {
    fontSize: "24px",
    marginBottom: "20px",
    fontWeight: "bold",
  },
  cardGrid: {
    display: "flex",
    flexWrap: "wrap",
    gap: "20px",
  },
  card: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
    padding: "20px",
    borderRadius: "10px",
    minWidth: "220px",
    color: "#2d3436",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    flex: 1
  },
  icon: {
    fontSize: "36px",
  },
  cardTitle: {
    fontSize: "18px",
    margin: 0,
  },
  cardCount: {
    fontSize: "24px",
    margin: 0,
    fontWeight: "bold",
  },
};

export default AdminDashboard;
